import React from 'react';
import PropTypes from 'prop-types';
import {SBPlateTroughsSectionContainer, SpearBioPlate} from './spearBioLabwareDefinition';
import SpearBioTroughWell from './SpearBioTroughWell';

function SBSectionMixedWells({...wellProps}) {
  const [mixedWellTemplate] = SpearBioPlate;

  return (
    <SBPlateTroughsSectionContainer gridRowEnd={9} gridColumnEnd={9}>
      {mixedWellTemplate.map((template) => (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <SpearBioTroughWell wellSections={template.wellSection} {...wellProps} />
      ))}
    </SBPlateTroughsSectionContainer>
  );
}

SBSectionMixedWells.propTypes = {
  labwareID: PropTypes.string.isRequired,
  wellStyle: PropTypes.object,
  wellEventProps: PropTypes.object,
  wellCommonProps: PropTypes.object,
};

SBSectionMixedWells.defaultProps = {
  wellStyle: {},
  wellEventProps: {},
  wellCommonProps: {},
};

export default SBSectionMixedWells;
